<div class="d-flex paginator">
  <div class="goto-icon left" [class.disabled]="!state.hasPrev" (click)="setCurrentPage(currentPage - 1)"></div>
  <div class="body_text m_x-1">{{state.label}}</div>
  <div class="goto-icon right" [class.disabled]="!state.hasNext" (click)="setCurrentPage(currentPage + 1)"></div>
</div>